module.exports = __webpack_public_path__ + "img/account.f8032907.svg";